<template>
  <div class="header">
    <div class="title">
      {{title}}
    </div>
  </div>
</template>

<script>
 export default {
   name: 'AUHeader',
   props: {
   },
   computed: {
     title() {
       return 'AI HackStack – 激发科学的AI想象力'
     },
     desc() {
       return this.$store.state.aboutus.desc;
     }
   },
   components: {
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .header{
   height: 10.83vw;
   /* background-image: url(~@/assets/image/aboutus/header.png); */
  background-image: url('/oss/images/frontpage/header-2025.png');
   background-size: 100vw;
   background-position-y: 330px;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   font-style: bold;
 }
 .title{
   margin-top: 60px;
   font-size: 1.875vw;
 }
 .desc{
   max-width: 57.86vw;
   margin-top: 2vw;
 }
 .desc>div{
   text-align: center;
   margin-bottom: 0.5vw;
 }
</style>
